import { render } from "./PolicyRule.vue?vue&type=template&id=3f1542e0"
import script from "./PolicyRule.vue?vue&type=script&lang=js"
export * from "./PolicyRule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__